module.exports = __webpack_public_path__ + "img/SpectroPicEmboss.c19467c4.png";